import React, { useId } from 'react';

// Logomarca do moon.land: lua crescente em "moonglow" (#f2e2a6).
// O recorte usa mask (não um círculo da cor do fundo) para funcionar sobre
// qualquer superfície; o id vem de useId porque a logo aparece várias vezes
// na mesma página e ids de mask duplicados quebram o SVG silenciosamente.
const MoonLogo = ({ size = 32 }) => {
  const maskId = useId();
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="moon.land">
      <defs>
        <mask id={maskId}>
          <rect width="64" height="64" fill="white" />
          <circle cx="43" cy="22" r="21" fill="black" />
        </mask>
        <radialGradient id={`${maskId}-g`} cx="35%" cy="35%" r="80%">
          <stop offset="0%" stopColor="#faf3d8" />
          <stop offset="100%" stopColor="#f2e2a6" />
        </radialGradient>
      </defs>
      <circle cx="32" cy="32" r="27" fill={`url(#${maskId}-g)`} mask={`url(#${maskId})`} />
      <circle cx="50" cy="47" r="2" fill="#f2e2a6" opacity="0.9" />
      <circle cx="55" cy="38" r="1.2" fill="#f2e2a6" opacity="0.6" />
    </svg>
  );
};

export default MoonLogo;
